// Swiper is imported already

/**
 * Product detail swiper
 */
class productDetailSwiper extends HTMLElement {
  constructor() {
    super();

    this.swiperElement = this.querySelector('[data-product-detail-swiper]');

    this.swiperOptions = {
      direction: 'horizontal',
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true
      }
    }


    this.init();
  }

  init() {
    window.addEventListener('load', (event) => {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
    });

    Fancybox.bind("[data-fancybox]", {
      animated: false,
      showClass: false,
      infinite: false,
      placeFocusBack: false,
      closeButton: "outside",
      Image: {
        fit: window.innerWidth < 768 ? "cover" : "contain",
        Panzoom: {
          maxScale: window.innerWidth < 768 ? .5 : 1
        }
      }
    });

    Fancybox.bind("[data-fancybox-sizeguide]", {
      mainClass: 'sizechart-wrapper',
      closeButton: false,
      on: {
        done: (fancybox, slide) => {
          const closeButton = slide.$content.querySelector('[data-fancybox-close]');
          closeButton.addEventListener('click', () => {
            fancybox.close();
          })
        }
      }
    });
  }

  updateSwiper() {
    this.swiperInstance?.update();
  }
}
if (!customElements.get('product-detail-swiper')) {
  customElements.define('product-detail-swiper', productDetailSwiper);
}

/**
 * Product options
 */
class productOptions extends HTMLElement {
  constructor() {
    super();

    // Default options
    this.options = {
      collection: "/collections/all",
      group: "",
      current: ""
    }

    // Get options from element data and combine with this.options
    const dataOptions = JSON.parse(this?.dataset?.options || "{}");
    this.options = {
      ...this.options,
      ...dataOptions
    };

    this.init();

    // get the fieldset for the color options
    this.colorFieldset = this.closest('[data-product-info-col').querySelector('[data-fieldset-swatches-color]');

    // Select automatically the previously chosen color when going to the same product in a different option
    this.handleAutomaticColorSelection();
  }

  init() {

    // Fetch from url
    fetch(this.options.collection + '/' + this.options.group + '?view=product-options')
      .then(response => response.text())
      .then(text => {

        const html = new DOMParser().parseFromString(text, 'text/html');
        const optionWrapper = html.querySelector('.product__options');

        if (optionWrapper) {
          optionWrapper.querySelector('[data-option-name="' + this.options.current + '"]')?.classList.add('product__option--active');
          this.appendChild(optionWrapper);

          // update the existing link in the summary to the same product with or without engraving
          if (this.options.engraving == "true") {
            this.updateEngravingLinks(optionWrapper);
          }
        }

        // set a product group identifier in the Session storage on Color option click
        if (this.colorFieldset) {
          this.querySelectorAll('[data-option-name]').forEach(option => option.addEventListener('click', () => {
            sessionStorage.previousProductGroup = JSON.parse(this.dataset.options).group;
          }));
        }

      })
      .catch(e => {
        console.error(e);
      });
  }

  /**
   * handleAutomaticColorSelection
   * @description Select automatically the previously chosen color when going to the same product group in a different option
   */
  handleAutomaticColorSelection() {

    // return if there's no fieldset with colors and delete the color related items in the Session storage
    if (!this.colorFieldset) return this.clearColorSessionStorageItems();

    // get the group identifier of the current Product
    this.currentProductGroup = JSON.parse(this.dataset.options).group;

    // check if the previous visited product is also part of this Group. If not, don't use the previously saved color
    if (sessionStorage.previousProductGroup && this.currentProductGroup !== sessionStorage.previousProductGroup) {
      this.clearColorSessionStorageItems();
    }

    // set the selected color value on load
    this.setSelectedColorOnLoad();

    // handle color change
    this.colorFieldset.addEventListener('change', this.handleColorChange);
  }

  /**
   * setSelectedColorOnLoad
   * @description Set the selected color on load according to the Session storage and get it to be used in other methods
   */
  setSelectedColorOnLoad() {
    // get the initial color value
    const colorFieldsetInputs = Array.from(this.colorFieldset.querySelectorAll('input'));
    let currentColorSelection = colorFieldsetInputs.find((radio) => radio.checked);
    this.selectedColorValue = sessionStorage.selectedColor || currentColorSelection.value;

    // select the saved color option if it doesn't match the current selection
    if (this.selectedColorValue !== currentColorSelection.value) {
      // select the right color option
      const newColorSelection = colorFieldsetInputs.find((radio) => radio.value === this.selectedColorValue);
      if (!newColorSelection) return;

      newColorSelection.checked = true;

      // fire the change event on variants.js
      this.variantRadios = document.querySelector('variant-radios');
      this.variantRadios.addEventListener('variantsComponentLoaded', () => {
        document.querySelector('variant-radios').onVariantChange();
      });
    }
  }

  /**
   * handleColorChange
   * @description Update the selectedColorValue property in the Session storage on color change
   */
  handleColorChange(event) {
    this.selectedColorValue = event.target.value;

    // save the current color selection in the Session storage
    sessionStorage.selectedColor = this.selectedColorValue;
  }

  /**
   * clearColorSessionStorageItems
   * @description Remove the color related items from the Session storage - selectedColor & previousProductGroup
   */
  clearColorSessionStorageItems() {
    if (sessionStorage.selectedColor) sessionStorage.removeItem('selectedColor');
    if (sessionStorage.previousProductGroup) sessionStorage.removeItem('previousProductGroup');
  }

  /**
   * updateEngravingLinks
   * @description Update the existing link in the summary to the same product with or without engraving - it can be a "Add engraving" or "Back to product" (without engraving) link
   */
  updateEngravingLinks(optionWrapper) {
    // get the engraving link element to use when replacing
    const engravingElemToTheOtherProduct = document.querySelector('[data-option-with-engraving-link]') || document.querySelector('[data-option-without-engraving-link]');
    const isCurrentProductWithoutEngraving = document.querySelector('[data-option-with-engraving-link]') ? true : false;

    // get the product link according to the current engraving option to replace
    const elementWithEngravingLink = isCurrentProductWithoutEngraving ? optionWrapper.querySelector('[data-link-with-engraving]') : optionWrapper.querySelector('[data-link-without-engraving]');

    // replace the engraving link
    engravingElemToTheOtherProduct && elementWithEngravingLink ? engravingElemToTheOtherProduct.href = elementWithEngravingLink.href : '';
  }

}
if (!customElements.get('product-options')) {
  customElements.define('product-options', productOptions);
}
